import React from "react";
import { HeadingWithList } from "../privacyPolicy/HeadingWithLIst";

const LISTELEMENTS: JSX.Element[] = [
  <p className="text-gray-500 pb-2" key="pp-list-1">
    <span className="font-semibold text-black">{"Agreement"}</span>
    {` means the terms and conditions of this End User terms and conditions Agreement.`}
  </p>,
  <div className="text-gray-500 pb-2" key="pp-list-2">
    <p className="pb-4">
      <span className="font-semibold text-black">{"Claim"}</span>
      {` shall mean any liability, suits, claims, actions, proceedings, losses, damages, judgments and reasonable costs.`}
    </p>
  </div>,
  <p className="text-gray-500 pb-2 " key="pp-list-3">
    <span className="font-semibold text-black">{"Documentation"}</span>
    {` shall mean the instructions and/or user manuals that describe installation, use, and/or operation of the Software.`}
  </p>,
  <p className="text-gray-500 pb-2 " key="pp-list-4">
  <span className="font-semibold text-black">{"Improvements"}</span>
  {` shall mean, with respect to the platform, all modifications and changes made, developed, acquired or conceived after the date hereof and during the entire term of this Agreement.`}
</p>,
<p className="text-gray-500 pb-2 " key="pp-list-5">
  <span className="font-semibold text-black">{"Intellectual Property Rights"}</span>
  {` shall mean copyright, patents, designs, trademarks, trade names, goodwill rights and trade secrets.`}
</p>,

<p className="text-gray-500 pb-2 " key="pp-list-6">
  <span className="font-semibold text-black">{"Website"}</span>
  {` refers to any and all versions of the software that has been developed and is owned by the Company and available for download and/or purchase from the Website.`}
</p>,
<p className="text-gray-500 pb-2 " key="pp-list-7">
  <span className="font-semibold text-black">{"Software"}</span>
  {` means and includes means the object code version of any software to which Customer is provided access as part of the service, including any updates or new versions.`}
</p>,
<p className="text-gray-500 pb-2 " key="pp-list-8">
  <span className="font-semibold text-black">{"Source Code"}</span>
  {` is the computer programming source code form of the Software in the form maintained by the Company, and includes all non-third-Party executables, libraries, components, and Documentation created or used in the creation, development, maintenance, and support of the Software as well as all updates, error corrections and revisions thereto provided by Company, in whole or in part.`}
</p>,
];

export const ListSection = () => {
  return (
    <HeadingWithList
      heading="Definitions"
      headingStyles="text-gray-500 font-bold text-2xl py-4"
      listElements={LISTELEMENTS}
    />
  );
};
